import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(theme => ({
  link: {
    paddingInlineStart: theme.spacing(0.5),
    paddingInlineEnd: theme.spacing(0.5),
    textDecoration: "none",
    "&:hover, &:focus": {
      backgroundColor: theme.palette.background.light,
      width:"inherit",
    },
  },
  linkActive: {
    backgroundColor: theme.palette.background.light,
    borderInlineEnd:"5px solid #4e80c5",
  },
  linkNested: {
    paddingInlineStart: 0,
    "&:hover, &:focus": {
      backgroundColor: "#FFFFFF",
    },
  },
  linkIcon: {
    marginInlineEnd: theme.spacing(1),
    color: theme.palette.text.secondary + "99",
    transition: theme.transitions.create("color"),
    width: 24,
    display: "flex",
    justifyContent: "center",
  },
  linkIconActive: {
    color: theme.palette.primary.main,
  },
  linkText: {
    padding: 0,
    color: theme.palette.text.secondary + "CC",
    transition: theme.transitions.create(["opacity", "color"]),
    fontSize: 16,
    // display:"flex",
    justifyContent: "center",
  },
  linkTextActive: {
    color: theme.palette.primary.main,
    display:"inherit",
  },
  linkTextHidden: {
    opacity: 0,
  },
  nestedList: {
    paddingInlineStart: theme.spacing(2) + 30,
  },
  sectionTitle: {
    marginInlineStart: theme.spacing(4.5),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    height: 1,
    backgroundColor: "#D8D8D880",
  },
}));
